import jan from "@/assest/blog1.png";
import feb from "@/assest/february.png";
import mar from "@/assest/march.png";

export const tourPackagesData = [
  {
    id: 1,
    slug: "adventure-in-the-alps",
    title: "Adventure in the Alps",
    duration: "7 Days",
    price: "$1500",
    image: jan,
    location: "Switzerland",
    description:
      "Embark on the Ghorepani Poon Hill Trek, a mesmerizing journey through rhododendron forests and charming Gurung villages. Witness breathtaking sunrise views over the Annapurna and Dhaulagiri ranges. Perfect for those seeking a moderate adventure with stunning Himalayan vistas.",
    availability: ["january", "february", "march"],
  },
  {
    id: 2,
    slug: "beach-paradise",
    title: "Beach Paradise",
    duration: "5 Days",
    price: "$1200",
    image: feb,
    location: "Maldives",
    description:
      "Embark on the Ghorepani Poon Hill Trek, a mesmerizing journey through rhododendron forests and charming Gurung villages. Witness breathtaking sunrise views over the Annapurna and Dhaulagiri ranges. Perfect for those seeking a moderate adventure with stunning Himalayan vistas.",
    availability: ["april", "may", "june"],
  },
  {
    id: 3,
    slug: "cultural-tour-of-japan",
    title: "Cultural Tour of Japan",
    duration: "10 Days",
    price: "$2500",
    image: mar,
    location: "Japan",
    description:
      "Embark on the Ghorepani Poon Hill Trek, a mesmerizing journey through rhododendron forests and charming Gurung villages. Witness breathtaking sunrise views over the Annapurna and Dhaulagiri ranges. Perfect for those seeking a moderate adventure with stunning Himalayan vistas.",
    availability: ["july", "august", "september"],
  },
];

export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
